import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {UserFisicaData, UserJuridicaData} from '../models/user-data.model';
import {UserDocumentTypeListRequest} from '../models/user-document-type-list-request';
import {UserDocumentModel} from '../models/user-document.model';


@Injectable({ providedIn: 'root' })
export class IncrementLimitApiService {

  private readonly profileBaseUrl = environment.apiBaseUrl + `/v1/core/portal/profile`;

  constructor(
    private http: HttpClient
  ){}

  incrementUserFisicaLimit(userFisicaData: any): Observable<any> {
    return this.http.post<any>(environment.apiBaseUrl + `/core/portal/profile/update_verification_level_2_dinamic`, userFisicaData);
  }

  incrementUserJuridicaLimit(userJuridicaData: any): Observable<any> {
    return this.http.post<any>(environment.apiBaseUrl + `/core/portal/profile/update_verification_level_2/company_data_dinamic`, userJuridicaData);
  }

  updateUserDocumentWithTypeId(userDocumentTypeListRequest: UserDocumentTypeListRequest): Observable<void>{
    return this.http.post<void>(environment.apiBaseUrl + `/core/portal/profile/update_user_document`, userDocumentTypeListRequest);
  }
  getDocuments(): Observable<UserDocumentModel[]> {
    return this.http.get<UserDocumentModel[]>(environment.apiBaseUrl + `/core/portal/profile/documents`);
  }
  getUserDocument(documentId: number): Observable<any> {
    return this.http.get<any>(environment.apiBaseUrl + `/core/portal/profile/file/${documentId}`);
  }

  // update_verification_level_2f
  // update_verification_level_2j/company_data
}
